import { alpha, Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { InstanceMode } from 'components/dataset-viewer';
import useBundleTranslation from 'i18n';

export default function ReportAlertInstanceModeSelection({
    instanceMode,
    onInstanceModeUpdate,
    showInstancesSelector,
}: {
    instanceMode: InstanceMode;
    onInstanceModeUpdate: (newInstanceMode: InstanceMode) => void;
    showInstancesSelector: boolean;
}) {
    const { t } = useBundleTranslation(['app/report/report-alert-rule']);
    return (
        <RadioGroup value={instanceMode} name="instance_mode" sx={{ mb: 0 }}>
            {(['current', 'lastTwo'] as InstanceMode[]).map((avOption) => {
                const isCurrent = instanceMode == avOption;
                const isDisabled = !showInstancesSelector && avOption == 'lastTwo';
                return (
                    <Box
                        sx={{
                            border: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.24)}`,
                            borderRadius: '4px',
                            mt: 1.5,
                            p: 1.5,
                            '&:first-of-type': {
                                mt: 0,
                            },
                            '&.active': {
                                borderColor: (theme) => theme.palette.primary.main,
                                boxShadow: (theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.24)}`,
                            },
                            '&:not(.active):hover': {
                                borderColor: (theme) => alpha(theme.palette.primary.main, 0.24),
                                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
                                cursor: 'pointer',
                            },
                        }}
                        className={isCurrent ? 'active' : undefined}
                        onClick={() => !isDisabled && onInstanceModeUpdate(avOption)}
                        key={avOption}
                    >
                        <FormControlLabel
                            value={avOption}
                            disabled={isDisabled}
                            control={<Radio data-test={`alert-rule-${avOption}_radio`} />}
                            label={
                                <Box
                                    sx={{
                                        fontWeight: 700,
                                        color: isCurrent ? 'primary.main' : 'text.primary',
                                    }}
                                >
                                    {t(`wizard.instance_mode_${avOption}.label`)}
                                </Box>
                            }
                            sx={{ my: '-5px', pointerEvents: 'none' }}
                        />
                        {isCurrent && (
                            <Box
                                sx={{
                                    pl: 3,
                                    pt: 0.5,
                                    color: (theme) => alpha(theme.palette.text.primary, 0.8),
                                }}
                            >
                                <Box
                                    sx={{ '.mark': { color: 'error.main' } }}
                                    dangerouslySetInnerHTML={{
                                        __html: t(`wizard.instance_mode_${avOption}.desc`, {
                                            markTagSTART: '<span class="mark">',
                                            markTagEND: '</span>',
                                            newLineTag: '<br />',
                                        }),
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                );
            })}
        </RadioGroup>
    );
}
